import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'fi',
  months: [
    'tammikuuta',
    'helmikuuta',
    'maaliskuuta',
    'huhtikuuta',
    'toukokuuta',
    'kesäkuuta',
    'heinäkuuta',
    'elokuuta',
    'syyskuuta',
    'lokakuuta',
    'marraskuuta',
    'joulukuuta',
  ],
  monthsShort: [
    'tammi',
    'helmi',
    'maalis',
    'huhti',
    'touko',
    'kesä',
    'heinä',
    'elo',
    'syys',
    'loka',
    'marras',
    'joulu',
  ],
  weekdays: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai'],
  weekdaysMin: ['S', 'M', 'T', 'K', 'T', 'P', 'L'],
  weekdaysShort: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
  formats: {
    LT: 'HH.mm',
    LTS: 'HH.mm.ss',
    lt: 'HH.mm',
    lts: 'HH.mm.ss',
    L: 'D.M.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY [klo] HH.mm',
    'LLL-Y': 'D. MMMM [klo] H.mm',
    LLLL: 'dddd D. MMMM YYYY [klo] HH.mm',
    'LLLL-Y': 'dddd D. MMMM [klo] HH.mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M.',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    'll-D': 'MMM YYYY',
    lll: 'D. MMM YYYY HH.mm',
    'lll-Y': 'D. MMM HH.mm',
    llll: 'ddd D.M.YYYY [klo] HH.mm',
    'llll-Y': 'ddd D.M. [klo] HH.mm',
    'll-Y+w': 'ddd D.M.',
    'LT+to': 'HH.mm ([UTC]Z)',
    'LLL+to': 'D. MMMM YYYY [klo] HH.mm ([UTC]Z)',
  },
  meridiem: { am: 'ap.', pm: 'ip.', AM: 'ap.', PM: 'ip.' },
  past: {
    y: { one: '%s v sitten', other: '%s v sitten' },
    M: { one: '%s kk sitten', other: '%s kk sitten' },
    w: { one: '%s vk sitten', other: '%s vk sitten' },
    d: { one: '%s pv sitten', other: '%s pv sitten' },
    h: { one: '%s t sitten', other: '%s t sitten' },
    m: { one: '%s min sitten', other: '%s min sitten' },
    s: { one: '%s s sitten', other: '%s s sitten' },
  },
  future: {
    y: { one: '%s v päästä', other: '%s v päästä' },
    M: { one: '%s kk päästä', other: '%s kk päästä' },
    w: { one: '%s vk päästä', other: '%s vk päästä' },
    d: { one: '%s pv päästä', other: '%s pv päästä' },
    h: { one: '%s t päästä', other: '%s t päästä' },
    m: { one: '%s min päästä', other: '%s min päästä' },
    s: { one: '%s s päästä', other: '%s s päästä' },
  },
  pastLong: {
    y: { one: '%s vuosi sitten', other: '%s vuotta sitten' },
    M: { one: '%s kuukausi sitten', other: '%s kuukautta sitten' },
    w: { one: '%s viikko sitten', other: '%s viikkoa sitten' },
    d: { one: '%s päivä sitten', other: '%s päivää sitten' },
    h: { one: '%s tunti sitten', other: '%s tuntia sitten' },
    m: { one: '%s minuutti sitten', other: '%s minuuttia sitten' },
    s: { one: '%s sekunti sitten', other: '%s sekuntia sitten' },
  },
  futureLong: {
    y: { one: '%s vuoden päästä', other: '%s vuoden päästä' },
    M: { one: '%s kuukauden päästä', other: '%s kuukauden päästä' },
    w: { one: '%s viikon päästä', other: '%s viikon päästä' },
    d: { one: '%s päivän päästä', other: '%s päivän päästä' },
    h: { one: '%s tunnin päästä', other: '%s tunnin päästä' },
    m: { one: '%s minuutin päästä', other: '%s minuutin päästä' },
    s: { one: '%s sekunnin päästä', other: '%s sekunnin päästä' },
  },
  abbr: {
    y: { one: '%s v', other: '%s v' },
    M: { one: '%s kk', other: '%s kk' },
    w: { one: '%s vko', other: '%s vko' },
    d: { one: '%s pv', other: '%s pv' },
    h: { one: '%s t', other: '%s t' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  full: {
    y: { one: '%s vuosi', other: '%s vuotta' },
    M: { one: '%s kuukausi', other: '%s kuukautta' },
    w: { one: '%s viikko', other: '%s viikkoa' },
    d: { one: '%s päivä', other: '%s päivää' },
    h: { one: '%s tunti', other: '%s tuntia' },
    m: { one: '%s minuutti', other: '%s minuuttia' },
    s: { one: '%s sekunti', other: '%s sekuntia' },
  },
  justNow: 'Juuri nyt',
  yesterday: 'Eilen',
  today: 'Tänään',
  tomorrow: 'Huomenna',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D. MMMM YYYY', end: 'D. MMMM YYYY' },
    'yl-1': { start: 'D. MMMM', end: 'D. MMMM YYYY' },
    ml: { start: 'D. MMMM', end: 'D. MMMM' },
    'ml-1': { start: 'D.', end: 'D. MMMM YYYY' },
    dl: { start: 'D.', end: 'D. MMMM' },
    y: { start: 'D. MMM YYYY', end: 'D. MMM YYYY' },
    'y-1': { start: 'D. MMM', end: 'D. MMM YYYY' },
    m: { start: 'D. MMM', end: 'D. MMM' },
    'm-1': { start: 'D.', end: 'D. MMM YYYY' },
    d: { start: 'D.', end: 'D. MMM' },
    Y: { start: 'ddd D. MMM YYYY', end: 'ddd D. MMM YYYY' },
    'Y-1': { start: 'ddd D. MMM', end: 'ddd D. MMM YYYY' },
    M: { start: 'ddd D. MMM', end: 'ddd D. MMM' },
    D: { start: 'ddd D. MMM', end: 'ddd D. MMM' },
    yt: { start: 'D. MMM YYYY [klo] H.mm', end: 'D. MMM YYYY [klo] H.mm' },
    mt: { start: 'D. MMM [klo] H.mm', end: 'D. MMM [klo] H.mm' },
    dt: { start: 'D. MMM [klo] H.mm', end: 'D. MMM [klo] H.mm' },
    t: { start: 'H.mm', end: 'H.mm' },
    'yt+to': { start: 'D. MMM YYYY [klo] H.mm', end: 'D. MMM YYYY [klo] H.mm ([UTC]Z)' },
    'mt+to': { start: 'D. MMM [klo] H.mm', end: 'D. MMM [klo] H.mm ([UTC]Z)' },
    'dt+to': { start: 'D. MMM [klo] H.mm', end: 'D. MMM [klo] H.mm ([UTC]Z)' },
    't+to': { start: 'H.mm', end: 'H.mm ([UTC]Z)' },
  },
};
const localeName: LocaleName = 'fi';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'ap.' : 'ap.';
    } else {
      return isLowerCase ? 'ip.' : 'ip.';
    }
  },
};
